import { render } from "./CtaCards.vue?vue&type=template&id=2e20cc52&scoped=true"
import script from "./CtaCards.vue?vue&type=script&lang=js"
export * from "./CtaCards.vue?vue&type=script&lang=js"

import "./CtaCards.vue?vue&type=style&index=0&id=2e20cc52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e20cc52"]])

export default __exports__